import styled from 'styled-components'

export const CguWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  align-items: center;
`

export const CenterWrapper = styled.div`
  padding: 1rem;
  max-width: ${(props) => (props.theme.isMobile ? '100%' : '60%')};
  display: flex;
  flex-direction: column;
  align-items: normal;
  & h2,
  h1 {
    padding: 2rem 0 2rem 0;
  }
  & p {
    padding-bottom: 1rem;
    text-align: justify;
  }
`
